import API from './API.js';
export default class FormData extends API {
  constructor() {
    super('dynamicForm');
  }

}
